import { BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, StateManager, useBCMSContext, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import { InfoBanner } from "components/shared/views/ConfirmBannerView";
import { PrimaryButton, SecondaryButton, UICheckbox } from 'components/ui';
import Classes from "model";
import React from 'react';
import "./styles.css";

/**
 * @function ImportParticipantsNACHAFileWidget
 * @return {React.Component}
 * @exported true
 * @description The widget that shows the imported NACHA files
 */

export default function ImportParticipantsNACHAFileWidget(props) {
  const navigate = useRoute();
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
    onChooseFile: () => {
      BCMSStateManagerCRUD.init(state)
        .update(["ui", "isFileChosen"], true)
        .submit(setState);
    },
    onImportFile: () => {
      BCMSStateManagerCRUD.init(state)
        .update(["ui", "isFileChosen"], false)
        .update(["ui", "isFileUploaded"], true)
        .update(["ui", "showFileUploadedBanner"], true)
        .update(["data", "selectedTemplate"], "select")
        .submit(setState);
      window.scrollTo(0, 0);
    },
    onCloseFileUploadedBanner: () => {
      BCMSStateManagerCRUD.init(state)
        .update(["ui", "showFileUploadedBanner"], false)
        .submit(setState);

    },
    onViewTemplates: () => {
      navigate("/achTemplates")
    },
    onViewParticipants: () => {
      navigate("/achParticipants")
    }
  });

  return (
    <StateManager state={{ data, ui }} controller={controller}>
      <WidgetContent />
    </StateManager>
  );
}

export const getDefaultData = () => ({
  // empty for now.
});
export const getDefaultUI = () => ({
  //showAddTemplateFormView: false
});

function WidgetContent(props) {
  const { data, ui, onCloseFileUploadedBanner, onChooseFile, onViewTemplates, onViewParticipants, onImportFile } = useStateManager();

  return (
    <WidgetContainer className="import-participants-nacha-file-widget">
      <WidgetView dataPoint="Import_Templates_And_Participants_From_A_Nacha_File_Label" text="Import Templates and Participants From A NACHA File">
        {ui.showFileUploadedBanner && <InfoBanner text="One or more files were imported successfully." onClick={onCloseFileUploadedBanner} />}
        <FormContainer>
          <FormRowView>
            <DisabledPrompt>
              <UICheckbox dataPoint={ `Add_Participants_If_Not_Existing` } label="Add Participants If Not Existing" value="" />
            </DisabledPrompt>
          </FormRowView>
          <FormRowView>
            <DisabledPrompt>
              <UICheckbox dataPoint={ `Use_First_Company_If_Not_Found` } label="Use First Company If Not Found" value="" />
            </DisabledPrompt>
          </FormRowView>
          <FormRowView>
            <DisabledPrompt>
              <UICheckbox dataPoint={ `Remove_Invalid_Entries_From_Template` } label="Remove invalid Entries from Template" value="" />
            </DisabledPrompt>
          </FormRowView>
          {ui.isFileUploaded &&
          <div className="import-log-container">
               <p>Import Log</p>
               <textarea className="file-uploading-textarea" readOnly defaultValue={
            `* Processing file "${data.fileName}"... \n* 5 participant(s) were added. \n* No participants were updated. \n* One or more files were imported successfully.`
          }>
          </textarea>
          </div>
     
 
        }
          <p className="max-file-size">Maximum file size: 500 KB</p>
          <FormButtonRow>
            <PrimaryButton text="View Templates" onClick={onViewTemplates} />
            <PrimaryButton text="View Participants" onClick={onViewParticipants} />
            <PrimaryButton dataPoint={ `Import_Templates_And_Participants_From_A_NACHA_File_Import_Button` } text="Import" className={ui.isFileChosen ? "import-button" : "disabled-button import-button"} onClick={onImportFile} />

            <div className="flex-container flex-horizontal align-center upload-file-button-container">
              <SecondaryButton dataPoint={ `Import_Templates_And_Participants_From_A_NACHA_File_Choose_File_Button` } text="Choose File" className="flex-width" onClick={onChooseFile} />
              {ui.isFileChosen ? <p>{data.fileName}</p> : <p>No file chosen</p>}
            </div>
          </FormButtonRow>
        </FormContainer>
      </WidgetView>
    </WidgetContainer>
  );
}